import { Injectable, Injector } from "@angular/core";
import { FiltrosService } from "../../../../../../layout/investigaciones/ver-respuestas/filtros.service";
import { PreguntaDTO, RespuestaUsuario } from "@DTOS";
import { ObtenerRespuestasSinComparativa } from "./ObtenerRespuestasSinComparativa";
import { Respuesta } from "../../../../../../layout/investigaciones/ver-respuestas/Respuesta";
import { CloudData } from "angular-tag-cloud-module";
import { ObtenerRespuestasComparativa } from "./ObtenerRespuestasComparativa";

@Injectable()
export class PasoObtenerRespuestas {
    constructor(private filtrosService: FiltrosService, private injector: Injector) {}

    public async obtenerRespuestas(
        pregunta: PreguntaDTO, respuestas: RespuestaUsuario[]
    ): Promise<Respuesta[] | CloudData[]> {
        return this.filtrosService.hayFiltroComparativo() ?
            await this.injector.get(ObtenerRespuestasComparativa).obtenerRespuestas(pregunta, respuestas)
            :
            await this.injector.get(ObtenerRespuestasSinComparativa).obtenerRespuestas(pregunta, respuestas);
    }
}
